.row {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  gap: var(--spacing-1);
}

.times {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: var(--font-size-s);
}

.muted {
  color: var(--color-grey);
}
